import { put, call, takeLatest } from "redux-saga/effects";
import _ from "lodash";

import { uploadFile } from "../../../utils/api";
import { defaultReturn, makePayload, generateDefaultActions, requestSaga } from "../../utils/helpers";
import { ToastSuccess, ToastError } from "../../../components/Global/Toasts/Toasty";

export const GET_LOAN_DETAILS_BY_ID = generateDefaultActions("GET_LOAN_DETAILS_BY_ID");
export const getLoanDetailsById = payload => makePayload(GET_LOAN_DETAILS_BY_ID.value, payload);
function* getLoanDetailsSaga(payload) {
  const url = `/loans/getLoanDetails/${payload.id}`;

  return yield requestSaga(GET_LOAN_DETAILS_BY_ID, url);
}

export const UPDATE_LOAN_DETAILS = generateDefaultActions("UPDATE_LOAN_DETAILS");
export const updateLoanDetails = payload => makePayload(UPDATE_LOAN_DETAILS.value, payload);
function* updateLoanDetailsSaga(payload) {
  const url = `/loans/updateLoanDetails/${payload.id}`;
  const updateResult = yield* requestSaga(UPDATE_LOAN_DETAILS, url, "POST", payload.loanDetails);
  const getResult = yield* getLoanDetailsSaga({ id: payload.id });
  if (!updateResult.error && !getResult.error) {
    ToastSuccess("Successfully updated");
  }
  if (payload.callback) {
    payload.callback();
  }
}

export const UPDATE_LOAN_DETAILS_FROM_SPREADSHEET = generateDefaultActions("UPDATE_LOAN_DETAILS_FROM_SPREADSHEET");
export const updateLoanDetailsFromSpreadsheet = (loanId, file) => makePayload(UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.value, { loanId, file });
function* updateLoanDetailsFromSpreadsheetSaga(payload) {
  try {
    payload.url = `/loans/updateLoanDetailsFromSpreadsheet/${payload.loanId}`;
    const response = yield call(uploadFile, payload, "POST");
    yield put({ type: UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.success, payload: response });
  } catch (error) {
    const userFriendlyError = _.get(error, "response.data.error", "Upload encountered error. Please choose a different file and try again.");
    yield put({ type: UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.failure, payload: { userFriendlyError, error } });
  }
}

export const CLEAR_UPLOAD_ERRORS = generateDefaultActions("CLEAR_UPLOAD_ERRORS");
export const clearUploadErrors = (loanId, file) => makePayload(CLEAR_UPLOAD_ERRORS.value, { loanId, file });
function* clearUploadErrorsSaga() {
  yield put({ type: CLEAR_UPLOAD_ERRORS.success });
}

const initialState = {
  loanDetails: {
    details: {},
    additionalAdvances: {},
    amortizationDetails: {},
    extensionTerms: {},
    ancillary: {
      lenders: []
    }
  }
};

export default function loanDetailsReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_LOAN_DETAILS_BY_ID.success:
      return defaultReturn(state, payload.data, "loanDetails");
    case UPDATE_LOAN_DETAILS.failure:
      ToastError("Update failed. Please ensure valid inputs.");
      break;
    case UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.value:
      return { ...state, showSpinner: true };
    case UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.success:
      return { ...state, showSpinner: false, uploadErrorMessage: undefined, uploadSuccessful: true, extractedLoanDetails: payload.data };
    case UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.failure:
      return { ...state, showSpinner: false, uploadErrorMessage: payload.userFriendlyError, uploadSuccessful: false };
    case CLEAR_UPLOAD_ERRORS.success:
      return { ...state, uploadSuccessful: undefined, extractedLoanDetails: undefined };
    default:
      break;
  }

  return state;
}

export function* loanDetailsSaga() {
  yield takeLatest(GET_LOAN_DETAILS_BY_ID.value, getLoanDetailsSaga);
  yield takeLatest(UPDATE_LOAN_DETAILS.value, updateLoanDetailsSaga);
  yield takeLatest(UPDATE_LOAN_DETAILS_FROM_SPREADSHEET.value, updateLoanDetailsFromSpreadsheetSaga);
  yield takeLatest(CLEAR_UPLOAD_ERRORS.value, clearUploadErrorsSaga);
}
